import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setHorarioEntrega } from '../../actions/pedidos'

export const calcularFechaDefault = () => {
  const d = new Date()
  const dia = d.getDay()
  if (dia === 6)
    d.setDate(d.getDate() + 2) // sábado → lunes
  else if (dia === 0) d.setDate(d.getDate() + 1) // domingo → lunes
  return d.toISOString().split('T')[0]
}

/**
 *
 * @param {Object} props
 * @param {boolean} props.pedidoGuardado
 */
const HorarioEntrega = ({ pedidoGuardado }) => {
  const dispatch = useDispatch()
  const pedido_cargando = useSelector(state => state.pedidos.isLoading)
  const lineas_pedido_cargando = useSelector(state => state.pedidos.isLoadingLines)
  const pedido = useSelector(state => state.pedidos.pedido)
  const [error, setError] = useState('')
  const prevLineasCargandoRef = useRef(false)
  const lastKnownDateRef = useRef('')

  const fechaMinima = calcularFechaDefault()

  useEffect(() => {
    if (pedido?.id_pedido && !pedido?.reservado_alfa_2) {
      dispatch(setHorarioEntrega(calcularFechaDefault()))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pedido?.id_pedido])

  useEffect(() => {
    if (pedido?.reservado_alfa_2) {
      lastKnownDateRef.current = pedido.reservado_alfa_2
    }
  }, [pedido?.reservado_alfa_2])

  useEffect(() => {
    if (prevLineasCargandoRef.current && !lineas_pedido_cargando) {
      if (pedido?.id_pedido && !pedido.reservado_alfa_2) {
        const dateToSet = lastKnownDateRef.current || calcularFechaDefault()
        dispatch(setHorarioEntrega(dateToSet))
      }
    }
    prevLineasCargandoRef.current = lineas_pedido_cargando
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lineas_pedido_cargando])

  function handleChange(event) {
    const valor = event.target.value
    if (valor && valor < calcularFechaDefault()) {
      setError('La fecha no puede ser anterior a la actual.')
    } else {
      setError('')
    }
    dispatch(setHorarioEntrega(valor))
  }

  return (
    <form className='form-default'>
      <div className='form-group'>
        <label htmlFor='fecha_entrega'>FECHA DE ENTREGA</label>
        <input
          className={`form-control${error ? ' is-invalid' : ''}`}
          type='date'
          onChange={handleChange}
          name='fecha_entrega'
          id='fecha_entrega'
          min={fechaMinima}
          required
          value={
            /^\d{4}-\d{2}-\d{2}$/.test(pedido?.reservado_alfa_2) ? pedido.reservado_alfa_2 : ''
          }
          disabled={pedidoGuardado || pedido_cargando}
        />
        {error && <div className='invalid-feedback'>{error}</div>}
      </div>
    </form>
  )
}

export default HorarioEntrega
